/* packages/volto-castle-theme/src/components/Blocks/HPFeatures/View.jsx */
import React from 'react';
import HPFeatures from './HPFeatures';

const View = (props) => {
  const data = (props && props.data) || {};
  const items = Array.isArray(data.items) ? data.items : [];
  const minHeight = typeof data.minHeight === 'number' ? data.minHeight : 520;
  const imagePosition = typeof data.imagePosition === 'string' ? data.imagePosition : 'right center';

  return <HPFeatures items={items} minHeight={minHeight} imagePosition={imagePosition} />;
};

export default View;
